export const orphan = {
  beforeMount(el) {
    el.innerHTML = el.innerHTML.trim().replace(/\s(\S*)$/, '&nbsp;' + '$1')
  },
}
